"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = sendAxiosPostRequest;
const axiosInstance_1 = require("./axiosInstance");
/** @deprecated - please instantiate the axios instance instead so that your app can use Types.LocalizedError for explicit error handling */
async function sendAxiosPostRequest(path, data, headers) {
    const axiosInstance = (0, axiosInstance_1.getAxiosInstance)();
    const config = {
        headers: {
            Accept: 'application/json',
            ...headers,
        },
    };
    return axiosInstance.post(path, data, config);
}
